export default (that) => [
  {
    text: that.$l('btn_tips_view_budget') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('btn_tips_edit_budget') || '编辑预算',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    data: {},
    disabled: ({ reportBudgetStatus }) => reportBudgetStatus !== 'N',
  },
  {
    text: that.$l('btn_tips_del_budget') || '删除预算',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    data: {},
    disabled: ({ reportBudgetStatus }) => reportBudgetStatus !== 'N',
  },
  {
    text: that.$l('btn_tips_submit_budget') || '审核预算',
    icon: 'el-icon-s-check',
    menuType: 'check',
    divided: true,
    allow: 'C',
    data: {},
    disabled: ({ reportBudgetStatus }) => reportBudgetStatus !== 'N',
  },
  {
    text: that.$l('btn_tips_adjust') || '调整预算',
    icon: 'el-icon-edit-outline',
    menuType: 'adjust',
    allow: 'J',
    data: {},
    disabled: ({ reportBudgetStatus }) => reportBudgetStatus !== 'Y',
  }
]
